import axiosInstance from "..";

export async function getPatient() {
  try {
    const response = await axiosInstance.get(`/patient`);
    if (response.status === 200) {
      return response.data?.patient;
    } else throw new Error("Could not get patient", response);
  } catch (err) {
    console.log(err);
  }
}

export async function getPatientByUid(uid) {
  try {
    const response = await axiosInstance.get(`get/patient?uid=${uid}`);
    if (response.status === 200) {
      return response.data;
    } else throw new Error("Could not get patient", response);
  } catch (err) {
    console.log(err);
  }
}

export async function createPatient(patient) {
  try {
    const response = await axiosInstance.post("/patient", patient);
    if (response.status === 200) {
      return response.data;
    } else throw new Error("Could not get patient", response);
  } catch (err) {
    console.log(err);
  }
}

export async function updatePatient(patient) {
  try {
    const response = await axiosInstance.post("/patient", patient);
    if (response.status === 200) {
      return response.data?.patient;
    } else throw new Error("Could not update patient", response);
  } catch (err) {
    console.log(err);
  }
}

/**
 * Every Patient record this login may act as. One phone can own more than one
 * (the desk-registered record and the self-registered portal one), and each
 * carries its own appointments.
 */
export async function getLinkedPatients() {
  try {
    const response = await axiosInstance.get("/patient/linked");
    if (response.status === 200) return response.data?.data || [];
    throw new Error("Could not get linked patients");
  } catch (err) {
    console.log(err);
    return [];
  }
}

/** Switch the session to one of those records; returns the re-signed token. */
export async function selectPatient(patientId) {
  try {
    const response = await axiosInstance.post("/auth/select-patient", {
      patientId,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err.response;
  }
}
